@if (content) {
  <div class="row-cols-1" [innerHTML]="content.richtext | sanitize"></div>
}
